import React from 'react';

const Statistics = () => {
    return (
        <div>Statistics Component</div>
    );
}

export default Statistics;
